module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/boxoffice/boxoffice-pos-status/boxoffice-pos-status.component.scss
// module id = ./src/app/routes/boxoffice/boxoffice-pos-status/boxoffice-pos-status.component.scss
// module chunks = 9